module.exports = __webpack_public_path__ + "img/img1.cbc46be0.png";